export const SAVE_DOCUMENT_CHANGES_TEXT =
    'Document unlocked: Any changes you made will be saved, and you will be logged out.';
export const DO_NOT_SAVE_DOCUMENT_CHANGES_TEXT =
    'Document locked: Any changes you made will not be saved, and you will be logged out.';